export default {
    name: "privacy",
    component: () => import(/* webpackChunkName: "users" */ '@/layouts/PrincipalLayout.vue'),
    children: [
        {
            path: '',
            name: 'users-privacy-index',
            beforeEnter: () => {
                const base = process.env.VUE_APP_RESILIENCIA_DOMAIN
                const normalized = base ? String(base).replace(/\/$/, '') : ''
                window.location.href = `${normalized}/privacy-notice`
                return false
            },
            component: () => import( /* webpackChunkName: "privacy-index" */ '@/modules/privacy/views/Index.vue'),
        },
        {
            path: 'terms-and-conditions',
            name: 'user-terms-conditions',
            beforeEnter: () => {
                const base = process.env.VUE_APP_RESILIENCIA_DOMAIN
                const normalized = base ? String(base).replace(/\/$/, '') : ''
                window.location.href = `${normalized}/terms-and-conditions-of-use`
                return false
            },
            component: () => import( /* webpackChunkName: "privacy-index" */ '@/modules/privacy/views/TermsAndConditions.vue'),
        }
    ]
}
